"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStatus = void 0;
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["ACTIVE"] = "ACTIVE";
    ContractStatus["EXPIRED"] = "EXPIRED";
})(ContractStatus || (exports.ContractStatus = ContractStatus = {}));
//# sourceMappingURL=contracts.js.map